<template>
  <div class="credit">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    ></SiruiSearch>
    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :row-style="rowStyle"
        :paging="true"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @dblclickEvent="dblclickEvent"
        @chooseClick="chooseClick"
        @currentChange="currentChange"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.field === 'creditType'">
              {{ creditTypeData[scope.row[item.field]] }}
            </span>
            <span v-else-if="item.field === 'auditStatus'">
              {{ auditStatusList[scope.row[item.field]] || '' }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- sunxueping 添加批量导入 -->
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="{ ...token }"
    ></sirui-upload>
  </div>
</template>

<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/purchaseSalesCenter/credit/credit.js';
  import DataBaseAPI from '@/api/dataBase';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import { filterEmpty, getUserCompanyList } from '@/common/js/util';
  import { dateFormatter } from '@/common/js/util';
  import tableMixins from '@/common/mixins/table.js';
  // ============ sunxueping 添加批量导入 ============
  import siruiUpload from '@/components/SiruiUpload';
  // ================================================

  export default {
    mixins: [tableMixins],
    components: {
      SiruiTable,
      SiruiSearch,
      //  sunxueping 添加批量导入
      siruiUpload,
      // =======================
    },
    name: 'projectMaintainList',
    data() {
      let routeQuery = this.$route.query || null;
      return {
        //  sunxueping 添加批量导入
        action: '/sales/creditLimitMaintain/importCreditLimitMaintainProject',
        // =======================
        load: false,
        img: './static/img/tips.png',
        query: {
          validDate: routeQuery && routeQuery.validDate ? routeQuery.validDate : null,
          invalidDate: routeQuery && routeQuery.validDate ? routeQuery.validDate : null,
          partnerName: routeQuery && routeQuery.partnerZhName ? routeQuery.partnerZhName : null,
          creditType: null,
          projectName: '',
          projectList: [],
          projectCompanyCodeList: null,
        },
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        creditTypeList: [], //授信类型下拉列表
        creditTypeData: [],
        enterprisePropertyData: [],
        accountsTypeList: [], //账款类型下拉列表
        rowData: {}, //被选中的列
        columnList: [],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          // { field: 'quotaTypeName', title: '额度维度', sortable: true },
          { field: 'projectCode', title: '项目编号', sortable: true },
          { field: 'projectName', title: '项目名称', sortable: true },
          { field: 'projectCompanyCode', title: '公司代码', sortable: true },
          { field: 'projectCompanyName', title: '公司名称' },
          { field: 'quotaTypeName', title: '账款类型' },
          { field: 'creditType', title: '授信类型' },
          { field: 'auditStatus', title: '审核状态' },
          { field: 'validDate', title: '授信有效期始' },
          { field: 'invalidDate', title: '授信有效期止' },
          { field: 'requestAmount', title: '项目授信额度（元）' },
          // { field: 'availableAmount', title: '项目可用额度（元）' },
          // { field: 'usedAmount', title: '项目占用额度（元）' },
          { field: 'createPersonName', title: '新增人' },
          { field: 'gmtCreate', title: '新增日期' },
        ],
        quotaTypeList: [],
        auditStatusList: {
          '01': '已保存',
          '02': '已提交',
          '03': '已生效',
          '04': '已驳回',
        },
      };
    },
    computed: {
      //搜索字段
      searchColumns() {
        return [
          ...(this.isWuMaoAccount
            ? [
                {
                  name: '项目编号',
                  type: 'searchTableSpec',
                  isMultiple: false,
                  searchType: 'projectListWumao',
                  prop: 'projectList',
                  extraData: {
                    projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
                    applyCompanyNo: this.userInfo.userInfo.companyCode,
                    applyCompanyName: this.userInfo.userInfo.companyName,
                  },
                },
              ]
            : [
                {
                  name: '项目编号',
                  type: 'searchTableSpec',
                  isMultiple: false,
                  searchType: 'projectInitiation',
                  prop: 'projectList',
                  extraData: {
                    projectInitiationStatusList: ['PIS04', 'PIS05'],
                  },
                },
              ]),
          {
            type: 'select',
            name: this.$t('contractAgency.company'),
            prop: 'projectCompanyCodeList',
            options: getUserCompanyList(),
            multiple: true,
          },
          {
            type: 'select',
            name: '账款类型',
            prop: 'quotaType',
            options: this.quotaTypeList,
          },
          {
            type: 'select',
            name: '授信类型',
            prop: 'creditType',
            options: this.creditTypeList,
          },
          {
            prop: 'validDate',
            name: '授信有效日期始',
            type: 'startDaterangePicker',
            placeholder: this.$t('credit.search.validDatePlaceholder'),
          },
          {
            prop: 'invalidDate',
            name: '授信有效日期止',
            type: 'endDaterangePicker',
            placeholder: this.$t('credit.search.invalidDatePlaceholder'),
          },
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      // sunxueping 添加
      token() {
        return {
          access_token: this.userInfo.userInfo.access_token,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          tenantCode: this.userInfo.userInfo.tenantCode,
        };
      },
      isWuMaoAccount() {
        return ['物贸', '国贸'].includes(this.userInfo.userInfo.businessGroup);
      },
    },
    /**页面必要代码Start */
    mounted() {
      this.getData();
      this.getButtonList();
      this.getDic();
    },
    methods: {
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e;
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then((res) => {
          this.columnList = res;
        });
      },
      //获取字典值
      getDic() {
        let tenantCode = this.userInfo.userInfo.tenantCode;
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'QUOTA_TYPE ', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.quotaTypeList = res.data.data;
            }
          });
        //授信类型
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, { dictType: 'credit_type', tenantCode })
          .then((res) => {
            if (0 == res.data.code) {
              this.creditTypeList = res.data.data;
              for (var item of res.data.data) {
                this.creditTypeData[item['value']] = item['label'];
              }
            }
          });
      },
      dblclickEvent(value) {
        const row = value.row;
        if (row.creditType == 'SX02') {
          if (['01', '04'].includes(row.auditStatus)) {
            this.addTemporary('Edit', row.id);
          } else {
            let path = {
              path: `/project/projectTemporaryDetail`,
              name: `projectTemporaryDetail`,
              meta: {
                keepAlive: true,
                title: '临时项目额度详情',
              },
              query: {
                id: row.id,
                isDetail: true,
              },
            };
            this.$store.dispatch('tagsView/addTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path);
              });
            });
          }
        }
      },
      //获取数据
      getData() {
        this.load = true;
        const query = this.$refs.siruiSearch.query;
        query.projectCodeList = [];
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        // query.projectCompanyCode = this.userInfo.userInfo.companyCode;
        // query.departmentCode = this.userInfo.userInfo.departmentCode;
        if (this.query.projectList !== 0) {
          this.query.projectList.map((item) => {
            query.projectCodeList.push(item.projectInitiationNo);
          });
        }
        // if (query.projectCompanyCodeList.length == 0) {
        //   query.projectCompanyCodeList = [this.userInfo.userInfo.companyCode];
        // }
        this.$axios
          .post('/sales/creditLimitMaintain/listCreditLimitMaintainProject', query)
          .then((res) => {
            this.load = false;
            if (0 == res.data.code) {
              this.tableData = res.data.data.list;
              this.$refs.siruiTable.setPageTotal(res.data.data.total);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          });
      },
      //行项目样式
      rowStyle({ row }) {
        let newDate = new Date(dateFormatter(new Date()));
        let invalidDate = new Date(row.invalidDate);
        if (invalidDate < newDate) {
          return {
            backgroundColor: '#f0f0f0',
          };
        }
      },
      //表格选中事件
      currentChange(row) {
        if (JSON.stringify(this.rowData) == '{}' || this.rowData.id != row.id) {
          this.rowData = row;
        } else if (this.rowData.id == row.id) {
          this.rowData = {};
        }
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        //新增
        if (type === 'add') {
          this.add();
        } else if (type === 'addTemporary') {
          this.addTemporary('Add');
        } else if (type === 'del') {
          //删除
          //判断按钮类型--删除
          this.del();
        } else if (type === 'export') {
          //导出
          this.export();
        } else if (type === 'edit') {
          if (JSON.stringify(this.multipleSelection) == '{}') {
            this.$message({
              showClose: true,
              message: this.$t('applicationCredit.msg.notSelectedModify'),
              type: 'error',
            });
          } else {
            let ids = [];
            const index = this.multipleSelection.findIndex((item) => item.creditType == 'SX02');
            if (index != -1) {
              return this.$message.warning('请选择正确的数据!');
            }
            this.multipleSelection.map((item) => {
              ids.push(item.id);
            });
            let path = {
              path: '/project/projectEdit',
              name: 'projectEdit',
              meta: {
                keepAlive: true,
                title: '项目额度修改',
              },
              query: { id: ids },
            };
            this.$store.dispatch('tagsView/addTabView', path).then(() => {
              this.$nextTick(() => {
                this.$router.push(path);
              });
            });
          }
        }
        // else if (type === 'editTemporary') {
        //   const selectedList = this.$refs.siruiTable.getCheckboxRecords();

        //   if (!selectedList) {
        //     this.$message.warning('请选择数据！');
        //   } else {
        //     if (selectedList.length != 1) {
        //       return this.$message.warning('仅可对一条数据进行更改！');
        //     }
        //     const index = selectedList.findIndex((item) => item.creditType == 'SX01');
        //     if (index != -1 || !['01', '04'].includes(selectedList[0].auditStatus)) {
        //       return this.$message.warning('请选择正确的数据！');
        //     }

        //     this.addTemporary('Edit', selectedList[0].id);
        //   }
        // }
        // ============ sunxueping 添加批量导入 ============
        else if (type == 'import') {
          this.handleImport();
        }
        // ================================================
      },
      // ============ sunxueping 添加批量导入 ============
      handleImport() {
        this.$refs.SiruiUpload.openDialog(true);
      },
      // ================================================
      //新增
      add() {
        let path = {
          path: '/project/projectAdd',
          name: 'projectAdd',
          meta: {
            keepAlive: true,
            title: '项目额度新增',
          },
          query: {},
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      addTemporary(type, quotaId) {
        let path = {
          path: `/project/projectTemporary${type}`,
          name: `projectTemporary${type}`,
          meta: {
            keepAlive: true,
            title: `项目额度${type == 'Add' ? '新增' : '编辑'}`,
          },
          query: {
            type: type,
            isDetail: false,
            id: quotaId,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //导出
      export() {
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        const query = this.$refs.siruiSearch.query;
        const params = filterEmpty(query);
        params.ids = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.ids.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.ids.push(item.id);
          });
        }
        // 获取数据
        this.$axios
          .post('/sales/creditLimitMaintain/exportProject', filterEmpty(params))
          .then((res) => {
            if (res.data.code === 0) {
              window.location.href = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      //删除
      del() {
        this.$confirmAction()
          .then(() => {
            let ids = [];
            this.multipleSelection.map((item) => {
              ids.push(item.id);
            });
            this.$axios.post(API.DELETE_APPLICATION_API, { ids }).then((res) => {
              if (0 == res.data.code) {
                //如果操作成功，直接返回列表
                this.$message({
                  type: 'success',
                  message: this.$t('message.success'),
                });
                this.getData();
              } else {
                //如果有错误返回，提示信息
                this.$alert(res.data.msg);
              }
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: this.$t('confirm.deleteCancelled'),
            });
          });
      },
      /**页面必要代码End */
    },
  };
</script>
